import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import navToggle from 'actions/NavToggle';
import { farmListSuccess, clearMessages } from 'actions/Farms';
import { doLogOut } from 'actions/Login';

import NavigationBar from 'mui-components/layouts/NavigationBar';
import LoaderPage from 'components/LoaderPage';
import { Box } from '@mui/material';

import { fetchRolePermistionList } from 'actions/RolesDetails';
import fetchMasterData from 'actions/MasterData';
import { fetchFarmList } from 'actions/Farms';
import { dataValidationPermission } from 'actions/GpsData';
import { fetchSupportAdminPermission } from 'actions/SupportAdminRole';
import { ENTER_TASKS, ENTER_FIELD } from 'constants/MixPanel';
import mixpanel from 'mixpanel-browser';

class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTermsAndCondition: false,
      fetchFarmListState: false,
      showMobileMenu1: false,
      showMobileMenu2: false,
      showMobileMenu3: false,
      showMobileMenu4: false,
    };
    this.openTermsAndCondition = this.openTermsAndCondition.bind(this);
    this.closeTermsAndCondition = this.closeTermsAndCondition.bind(this);
  }
  componentDidMount = () => {
    const { getRolesDetails, userDetails, dataPermission, getMasterData, supportAdminPermission } = this.props;
    const { idToken } = userDetails.data;
    getRolesDetails(idToken);
    dataPermission(idToken);
    supportAdminPermission();
    getMasterData();
  };

  componentDidUpdate = () => {
    const { getFarmList, userDetails, hasSupportAdminRole, farmList } = this.props;
    const { lastaccessedFarm } = userDetails.data;
    const { fetchFarmListState } = this.state;
    let version = "v1";
    if(!fetchFarmListState && hasSupportAdminRole.data !== null) {
      if(hasSupportAdminRole.data) {
        version = "v2";
      }
      if(!farmList.data) {
        if(localStorage.getItem("selectedFarmId") === null &&  localStorage.getItem("selectedFarmName") === null) {
          getFarmList(lastaccessedFarm,version);
        } else {
          getFarmList(localStorage.getItem("selectedFarmId"),version);
        }
        this.setState({
          fetchFarmListState: true
        });
      }
    }
  }

  openTermsAndCondition = () => {
    this.setState ({
      showTermsAndCondition: true
    });
  }

  closeTermsAndCondition = () => {
    this.setState ({
      showTermsAndCondition: false
    });
  }

  handleClickEvent = (eventValue) => {
    const { userDetails } = this.props;
    if(eventValue === '1') {
      mixpanel.identify(userDetails.data.id);
      mixpanel.track(ENTER_FIELD);
      this.setState({
        showMobileMenu1: true,
        showMobileMenu2: false,
        showMobileMenu3: false,
        showMobileMenu4: false
      });
    } else if(eventValue === '2') {
      mixpanel.identify(userDetails.data.id);
      mixpanel.track(ENTER_TASKS);
      this.setState({
        showMobileMenu1: false,
        showMobileMenu2: true,
        showMobileMenu3: false,
        showMobileMenu4: false
      });
    } else if(eventValue === '3') {
      this.setState({
        showMobileMenu1: false,
        showMobileMenu2: false,
        showMobileMenu3: true,
        showMobileMenu4: false
      });
    } else {
      this.setState({
        showMobileMenu1: false,
        showMobileMenu2: false,
        showMobileMenu3: false,
        showMobileMenu4: true
      });
    }
  }

  render() {
    const {
      props: { children, farmList, rolesDetails, userDetails, location, masterData, intl, history, hasSupportAdminRole }
    } = this;
    const error = farmList.hasError || rolesDetails.hasError || masterData.hasError;
    const profileDisplayCheck = location && location.pathname.includes('profilesettings');
    return (
      <Box sx={{ backgroundColor: '#f0f0f0', overflow: 'hidden', position: 'relative' }}>
        <NavigationBar 
          farmList={farmList}
          rolesDetails={rolesDetails}
          masterData={masterData}
          profileDisplayCheck={profileDisplayCheck}
          userDetails={userDetails}
          children={children}
          intl={intl}
          error={error}
          history={history}
          hasSupportAdminRole={hasSupportAdminRole}
        />
        {/* Loader if user is logging out */}
        {userDetails.isLogoutLoading ? <LoaderPage /> : null}
      </Box>
    )
  }
}

const mapStateToProps = state => ({
  userDetails: state.userDetails,
  rolesDetails: state.RolesDetails,
  farmList: state.farmList,
  masterData: state.masterData,
  hasSupportAdminRole: state.SupportAdminRole,
  navBarToggle: state.NavToggle,
  hasValidationPermision: state.GpsData
});

const mapDispatchToProps = dispatch => ({
  getFarmList: (lastaccessedFarm, version) => dispatch(fetchFarmList(lastaccessedFarm, version)),
  dataPermission: token => dispatch(dataValidationPermission(token)),
  getRolesDetails: token => dispatch(fetchRolePermistionList(token)),
  getMasterData: () => dispatch(fetchMasterData()),
  supportAdminPermission: () => dispatch(fetchSupportAdminPermission()),
  navigationToggle: bool => dispatch(navToggle(bool)),
  updateActiveFarm: (data, activeform) => dispatch(farmListSuccess(data, activeform)),
  clearFarmMessages: () => dispatch(clearMessages()),
  loggingOut: (token, activeFarmId) => dispatch(doLogOut(token, activeFarmId))
});

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AppLayout)));
